import { systemResetService } from "./system-reset-service.js";

// Sistema Operacional em Modo Limpo (Sem dados fictícios)
export async function runAutoSeeder(_platform: any) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('auto_seeder_v1');
    localStorage.removeItem('inspect_seeded');

    // Se o reset controlado inicial ainda não foi executado no ambiente, executa com backup transacional
    if (!localStorage.getItem('inspect_system_clean_reset_done')) {
      console.log("[autoSeeder] Executando Reset Controlado Inicial com Backup...");
      systemResetService.executeControlledReset({ executedBy: 'Sistema (Auto-Reset)' });
    }

    // Limpeza de equipamentos fictícios legados
    try {
      const eqData = localStorage.getItem('inspect_equipments');
      if (eqData) {
        const entries: [string, any][] = JSON.parse(eqData);
        const cleaned = entries.filter(([id, eq]) => {
          const isMock = id.startsWith('DEMO') || id === 'V-101' || id === 'TQ-201' || id === 'P-301' || (eq?.tag === 'V-101' && eq?.name?.includes('Separador')) || eq?.clientId === 'mock-client' || eq?.clientId === 'ind-beta' || eq?.clientId === 'refinaria-alfa' || eq?.clientId === 'inspect-main';
          return !isMock;
        });
        localStorage.setItem('inspect_equipments', JSON.stringify(cleaned));
      }
    } catch (e) {
      console.warn("Erro ao limpar dados legados:", e);
    }

    // Limpeza contínua desativada: dados fictícios não são mais gerados.
  }
}

